const messages = {
    selectCountryParagraph1: 'header.selectCountryBanner.paragraph1',
    selectCountryParagraph2: 'header.selectCountryBanner.paragraph2',
    allGood: 'header.selectCountryBanner.allGood',
};
export default messages;
//# sourceMappingURL=messages.js.map